import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("Unbehandelter Fehler in der UI:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    <h2>Es ist ein unerwarteter Fehler aufgetreten.</h2>
                    <p>Bitte lade die Seite neu. Sollte das Problem weiter bestehen, wende dich an den Administrator.</p>
                    <button onClick={() => window.location.reload()}>Seite neu laden</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
